/*
Model defined for Maintaining Permission Responses. It can also be used for transferring model
*/
export class RateRangeModel {
    baseRateInINR: number;
    cardRateInINR: number;
    currencyCode: string;
    minimumRateInINR: number;
    nrr: number;
    defaultRate: any;
    revenueModel: string;
    revenueSharePercentage: number;
    notificationMessageResponses: notificationMessageResponsesModel;
}
export class notificationMessageResponsesModel {
    message: string;
    notificationPriority: string;
    title: string;
}


// WEBPACK FOOTER //
// ./src/app/_models/rates/RateRangeModel.ts